/* WCF-040 card swatch runtime */
(() => {
  if (window.__wcfCardColorSwatchesInstalled) return;
  window.__wcfCardColorSwatchesInstalled = true;

  function handleSwatch(event) {
    const target = event.target;
    const swatch = target && typeof target.closest === 'function'
      ? target.closest('[data-wcf-color-swatch]') : null;
    if (!swatch) return;
    const card = swatch.closest('.card-wrapper');
    if (!card) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    const image = card.querySelector('img[data-wcf-primary-image]');
    if (image && swatch.dataset.wcfImageUrl) {
      image.src = swatch.dataset.wcfImageUrl;
      image.removeAttribute('srcset');
      image.alt = swatch.dataset.wcfImageAlt || image.alt;
    }
    card.querySelectorAll('[data-wcf-color-swatch]').forEach((button) => {
      const active = button === swatch;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  }

  document.addEventListener('pointerdown', handleSwatch, true);
  document.addEventListener('click', handleSwatch, true);
})();